import { ComponentType } from 'react';

export function withDefaultProps <T>(defaultProps: Partial<T>) {
    return (Component: ComponentType<T>): ComponentType<T> =>
        props => <Component {...defaultProps} {...props} />;
}
